import {
  GridColDef,
  GridInitialState,
  GridRenderCellParams,
} from "@mui/x-data-grid-premium";
import React from "react";
import { useError } from "../../contexts/ErrorContext";
import useApi from "../../hooks/useGaneshApi";
import GaneshDataGrid from "../DataGrid/GaneshDataGrid";
import { useQuery } from "@tanstack/react-query";

interface SchemaConfigTableProps_T {
  datasetType: "sample" | "delivery";
  datasetId?: string;
  customHeight?: string;
}

const defaultGridState: GridInitialState = {
  filter: {
    filterModel: {
      items: [
        {
          field: "has_attribute",
          operator: "is",
          value: "true",
        },
      ],
    },
  },
  sorting: { sortModel: [{ field: "attribute", sort: "asc" }] },
  pagination: { paginationModel: { pageSize: 50, page: 0 } },
  pinnedColumns: { left: [] },
  columns: { columnVisibilityModel: {} },
  density: "compact",
  aggregation: {},
};

const columns_def: GridColDef[] = [
  { field: "parent_key", headerName: "Parent Key", width: 250 },
  { field: "attribute", headerName: "Attribute", width: 250 },
  {
    field: "has_attribute",
    headerName: "Has Attribute",
    width: 100,
    type: "boolean",
  },
  { field: "label", headerName: "Label", width: 250 },
  {
    field: "details",
    headerName: "Details",
    width: 350,
    renderCell: (params: GridRenderCellParams) => {
      if (params.value && params.value === "{}") {
        return null;
      }
      return params.value;
    },
  },
];

const SchemaConfigTable: React.FC<SchemaConfigTableProps_T> = ({
  datasetId,
  datasetType,
  customHeight,
}) => {
  const { apiRequest } = useApi();

  const { data: schemaConfigData = [], isLoading } = useQuery<any[], Error>({
    queryKey: ["schemaConfig", datasetType, datasetId],
    queryFn: async () => {
      const response = await apiRequest<any[]>(
        `/v1/schemas/${datasetType}/${datasetId}`,
        { method: "GET" }
      );
      if (response.error) {
        throw new Error(response.error);
      }
      return response.data || [];
    },
    enabled: !!datasetId,
  });

  return (
    <GaneshDataGrid
      loading={isLoading}
      data={schemaConfigData}
      columns={columns_def}
      gridId={`${datasetType}SchemaConfigGrid`}
      defaultGridState={defaultGridState}
      customHeight={customHeight}
    />
  );
};

export default SchemaConfigTable;
